import psHttp from '@patsnap/common-ps-http';
import { HiroProxy } from '../proxy';
import { Tracker } from './tracker';

export const HostProps = Symbol('HostProps');

interface Message {
    [key: string]: Message | string;
}

/**
 * 宿主属性
 */
export interface HostProps {
    locale: string;
    /**
     * 国际化文案 cn en jp tw
     */
    messages?: Message;
    httpRequest: typeof psHttp;
    /** 宿主传入的 HeaderService 实例 */
    headerService: any;
    /**
     * 埋点，事件上报
     */
    tracker?: Tracker;
    proxy: HiroProxy;
    /** 开启的智能体 code */
    enabledAgentCodes: string[];
    /** 智能体配置, key 为智能体 code, value 为智能体配置(后端定义的类型无法确定，所以不做字段格式转换了) */
    agentConfigs?: Record<string, any>;
}
